export default __webpack_public_path__ + "static/media/ic_costnew.c6ce1e93.svg";